import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Table } from "../../../Common/Table";
import {
  getDateTimeLocale,
  getDateFormats,
} from "../../../../utils/get-date-time-locale";

import { format } from "date-fns";
import Toastmessage from "../../../Common/ToastMessage";
import { Check, Clear } from "@material-ui/icons";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  makeStyles,
  Paper,
  Typography,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Title } from "./styles";
import { actionShowSpinner } from "../../../../redux-flow/action/Wrapper/Spinner";
import { getBySlotId } from "../../../../services/finalDeliberations.service";
import { finalDeliberationOptions } from "../../../../services/formCombos.service";
import { getComplianceOpinionName } from "../../utils/index";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  subtitle: {
    ...theme.typography.subtitle1,
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
}));

const FinalDeliberation = ({ t, history, match, actionShowSpinner, i18n }) => {
  const columns = [
    {
      title: t("forms.committeeName").toUpperCase(),
      field: "committee",
    },
    {
      title: t("menu.finalDeliberations.info.status").toUpperCase(),
      field: "status",
    },
    {
      title: t("forms.committee.labels.date").toUpperCase(),
      field: "date",
    },
    {
      title: t("slots.finalElevation").toUpperCase(),
      field: "finalElevation",
    },
  ];
  const classes = useStyles();
  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });
  const [slot, setSlot] = useState({});

  const {
    params: { slotId },
  } = match;

  useEffect(() => {
    actionShowSpinner(true);

    getBySlotId(slotId)
      .then(({ data: slot }) => {
        setSlot({
          ...slot,
          approvals: slot.approvals.map((approval) => ({
            id: approval.id,
            committee: approval.committeeName,
            status: finalDeliberationOptions[i18n.language].find(
              (deliberation) => deliberation.id === approval.deliberation
            ).name,
            date: format(
              new Date(approval.date),
              getDateFormats(i18n.language),
              {
                locale: getDateTimeLocale(i18n.language),
              }
            ),
            finalElevation: approval.finalElevation ? <Check /> : <Clear />,
          })),
        });
      })
      .finally(() => actionShowSpinner(false));
  }, [slotId, i18n]);

  return (
    <>
      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <Grid container className={classes.root} style={{ width: "100%" }}>
        <Grid
          container
          item
          direction="row"
          justify="space-between"
          className={classes.spacer}
        >
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h4">
              {t("menu.finalDeliberations.info.title")}
            </Typography>
          </Grid>
        </Grid>
        <Paper style={{ width: "100%" }} elevation={1} className={classes.root}>
          <Title>Informações Gerais</Title>
          <Grid
            container
            direction="row"
            spacing={3}
            style={{ marginBottom: "22px" }}
          >
            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="theme"
                id="theme"
                value={slot.theme || ""}
                label={t("slots.theme")}
                fullWidth
                required
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="modality"
                id="modality"
                value={slot.modality || ""}
                label={t("slots.modality")}
                fullWidth
                required
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="objective"
                id="objective"
                value={slot.objective || ""}
                label={t("slots.objective")}
                fullWidth
                required
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="institution"
                id="institution"
                value={slot.intitution || ""}
                label={t("slots.institution")}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="value"
                id="value"
                value={slot.value || ""}
                label={t("value")}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="approvedValue"
                id="approvedValue"
                value={slot.approvedValue || ""}
                label={t("approvedValue")}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="complianceOpinion"
                id="complianceOpinion"
                value={getComplianceOpinionName(slot.complianceOpinion)}
                label={t("slots.complianceOpinion")}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="requester"
                id="requester"
                value={slot.requester || ""}
                label={t("slots.requester")}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} xs={6}>
              <TextField
                disabled={true}
                name="directorShip"
                id="directorShip"
                value={slot.directory || ""}
                label={t("slots.board")}
                fullWidth
              />
            </Grid>

            <Grid item lg={3} xs={3}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  {t("slots.budget.title")}
                </FormLabel>
                <RadioGroup
                  disabled={true}
                  aria-label="budget"
                  name="budget"
                  value={slot.budgeted || ""}
                  required={true}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio size="small" />}
                    label={t("slots.budget.yes")}
                    disabled={true}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio size="small" />}
                    label={t("slots.budget.no")}
                    disabled={true}
                  />
                  <FormControlLabel
                    value="na"
                    control={<Radio size="small" />}
                    label={t("slots.budget.na")}
                    disabled={true}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Title>Histórico de aprovações</Title>

          <Table columns={columns} data={slot.approvals} />
        </Paper>
      </Grid>
    </>
  );
};

const withRouterFinalDeliberation = withRouter(FinalDeliberation);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FinalDeliberationConnect = connect(
  null,
  mapDispatchToProps
)(withRouterFinalDeliberation);

export default withTranslation()(FinalDeliberationConnect);
